// Shared by the app shell on every route, including /start while its
// safe-area check delays application rendering.
export const catchyViewportContent =
  "minimum-scale=1, initial-scale=1, maximum-scale=1, user-scalable=no, width=device-width, shrink-to-fit=no, viewport-fit=cover";
